import React, { useState, useMemo } from 'react'
import {
  Navbar,
  useWindowDimensions,
  Avatar,
  IconClose,
  Modal,
  NavbarMobile,
  ModalLayout,
  ListItem,
  IconInfo,
  IconSettings,
  IconArrowRight
} from '@Knowledge-OTP/znk-ui-components'

// import SwitchPlatform from './SwitchPlatform'
// import getEnv from '../../helpers/getEnv'

import { useItems } from './Header/items'
import { useHistory/** , useLocation*/ } from 'react-router'
import { useSelector } from 'react-redux'
import useTranslation from '../../i18n/useTranslation'
import EditAvatar from '../EditAvatar'


const Layout = (props) => {
  // const enviroment = getEnv()
  const { translate } = useTranslation()
  const history = useHistory()
  const { breakWidth } = useWindowDimensions()
  const { items, secondaryItems, toolOptions, settingOption } = useItems()
  const [openToolsMobile, setOpenToolsMobile] = useState(false)
  const [openSettingsMobile, setOpenSettingsMobile] = useState(false)
  const toolsMenuItem = useMemo(
    () => ({
      href: '#tools',
      Body: (
        <span className={'d-flex flex-row align-items-center h45 nav-link-option w-100'} onClick={() => setOpenToolsMobile(true)} style={{ cursor: 'pointer' }}>
          <IconInfo className={'mr-2'} size={20} /> {translate('menu.tools.tools')}
        </span>
      ),
      linkClass: 'm-0 w-100 nav-link-option',
      itemClass: 'mr-1',
      label: ''
    }),
    [translate]
  )
  const settingsMenuItem = useMemo(
    () => ({
      href: '#settings',
      Body: (
        <span className={'d-flex flex-row align-items-center h45 nav-link-option w-100'} onClick={() => setOpenSettingsMobile(true)} style={{ cursor: 'pointer' }}>
          <IconSettings className={'mr-2'} size={20} /> {translate('menu.settings.settings')}
        </span>
      ),
      linkClass: 'm-0 w-100 nav-link-option',
      itemClass: 'mr-1',
      label: ''
    }),
    [translate]
  )
  const mobileItems = useMemo(
    () => (breakWidth === 'SM' ? [...items, toolsMenuItem, settingsMenuItem] : items),
    [breakWidth, items, toolsMenuItem, settingsMenuItem]
  )
  const {firstName, lastName, avatar: avatarUser, refetch} = useSelector((state) => state.user)
  const [isReset, setIsReset] = useState(null)
  const [openCrop, setOpenCrop] = useState(false)
    const toggleCrop = () => {
    setOpenCrop(!openCrop)
  }
  const onChangeAvatar = (file) => {
    setOpenCrop(true)
  }
  const fetch = async () => {
    await refetch()
    setIsReset(isReset === null ? true : !isReset)
  }
  const onWorkSpace = useMemo(
    //sirve para eliminar el padding de bodypublic
    // cuando el tamaño de pantalla es SM
    () => {
      return ['/workspace/colleges', '/workspace/tasks'].includes(history.location.pathname)
      // eslint-disable-next-line
    }, [history, breakWidth]
  )

  // const location = useLocation()
  
  
  const isCalendar = false 
  // /^\/calendar\/.*/.test(location.pathname) ||
  //   /^\/calendar\?.*/.test(location.pathname) || /^\/calendar/.test(location.pathname)

  // const isLessonList = /^\/lessons\/.*/.test(location.pathname) ||
  //   /^\/lessons\?.*/.test(location.pathname) || /^\/lessons/.test(location.pathname)


  return (
    <>
      <Modal
        className='modal-centered medium modal-colored white-modal pr-3 pl-3 '
        isOpen={openCrop}
        toggle={toggleCrop}
        backdrop='static'
        style={{height: '95%'}}
        StyleModalBody={{height: '100%'}}
        classModalBody='contentHeight'
        Head={
          <div className='modal-header p-0 m-0'>
            <div className='d-flex justify-content-between w-100 pt-7 pb-4 px-7'>
              <h2 className='font-weight-bold'>{translate('profile.actions.changeAvatar.title')}</h2>
              <IconClose onClick={toggleCrop} className='text-gray' />
            </div>
          </div>
        }
      >
        <EditAvatar userId={null} fetch={fetch} toogle={toggleCrop}/>
      </Modal>
      <div
        className={`w-100 h-100 ${breakWidth === 'SM' ? 'bg-light' : 'bg-light'}`}
      >
        {breakWidth === 'SM' ? (
          <div className='d-flex flex-column align-items-center h-100'>
            <div className='navPublic w-100'>
              {/* <Navbar
                light
                expand='xs'
                className=''
                navClass=''
                history={history}
                isPublic={false}
                items={items}
              /> */}
              <NavbarMobile
                items={mobileItems}
                FootBrand={
                  <div className='navbar-brand d-flex flex-column justify-content-end'>
                      <span
                        className='d-flex justify-content-between align-items-center'
                        onClick={() => history.push('/')}
                        style={{cursor: 'pointer'}}
                      >
                        <Avatar
                          name={`${firstName} ${lastName}`}
                          uri={avatarUser}
                          size='avatar-small'
                          activateChange={true}
                          onClickImage={onChangeAvatar}
                          isReset={isReset}
                        />
                        <span className='h4 d-none d-xl-block'>
                          &nbsp;{firstName}
                        </span>
                      </span>
                  </div>
                }
              />
            </div>
            <div 
              style={
                isCalendar
                  ? {overflowY: 'hidden'}
                  : {}
              }
              className={`col-12 bodyPublic thisbody ${onWorkSpace ? 'pr-0' : ''}`}>{props.children}</div>
          </div>
        ) : (
          <div className='d-none d-md-flex h-100'>
            <div className='col-1 h-100 p-0'>
              <Navbar
                light
                expand='md'
                className='d-none d-md-flex flex-column h-100'
                navClass='d-flex justify-content-start flex-column'
                isPublic={false}
                items={items}
                secondaryItems={secondaryItems}
                navSecondaryClass={'h-100 d-flex justify-content-end flex-column'}
                FootBrand={
                  <div className='navbar-brand d-flex flex-column justify-content-end'>
                      <span
                        className='d-flex justify-content-between align-items-center mb-2'
                        onClick={() => history.push('/')}
                        style={{cursor: 'pointer'}}
                      >
                        <Avatar
                          name={`${firstName} ${lastName}`}
                          uri={avatarUser}
                          size='avatar-small'
                          activateChange={true}
                          onClickImage={onChangeAvatar}
                          isReset={isReset}
                        />
                        <span className='h4 d-none d-xl-block'>
                          &nbsp;{firstName}
                        </span>
                      </span>
                  </div>
                }
              />
            </div>
            <div 
            style={
              isCalendar
                ? {overflowY: 'hidden'}
                : {}
            }
            className='col-11 h-100 bodyPublic d-flex flex-column p-0 hidde-scroll-vertical'>              
              {props.children}
            </div>
          </div>
        )}
        {/* {['beta', 'local'].includes(enviroment) && <SwitchPlatform/>} */}
        {/* Mobile bottom-sheets for Tools and Settings to mimic FloatButton look & behavior */}
        <ModalLayout
          className={`${breakWidth === 'SM' ? 'modal-botbar' : 'modal-centered'} modal-hauto modal-noborder-bottom`}
          disabledScrollAnimation={false}
          isOpen={openToolsMobile}
          toggle={() => setOpenToolsMobile(!openToolsMobile)}
          topHead={
            <div className={'d-flex flex-row align-items-center'}>
              <span className={'h2 text-title m-0'}>{translate('menu.tools.tools')}</span>
            </div>
          }
        >
          <div className={'m-0 p-0 d-flex flex-column'}>
            {toolOptions.map(({ Icon, label, onClick = () => {} }, idx) => (
              <ListItem
                key={`tool-${idx}`}
                onClick={() => { onClick(); setOpenToolsMobile(false) }}
                className={'w-100 hover-no-border py-2'}
                hasHover
                Left={<span className={'d-flex flex-row align-items-center'}><Icon size={15} className={'mr-2'} />{label}</span>}
                Right={<div className={'hover-icon'}><IconArrowRight /></div>}
                showBottomLine
              />
            ))}
          </div>
        </ModalLayout>
        <ModalLayout
          className={`${breakWidth === 'SM' ? 'modal-botbar' : 'modal-centered'} modal-hauto modal-noborder-bottom`}
          disabledScrollAnimation={false}
          isOpen={openSettingsMobile}
          toggle={() => setOpenSettingsMobile(!openSettingsMobile)}
          topHead={
            <div className={'d-flex flex-row align-items-center'}>
              <span className={'h2 text-title m-0'}>{translate('menu.settings.settings')}</span>
            </div>
          }
        >
          <div className={'m-0 p-0 d-flex flex-column'}>
            {settingOption.map(({ Icon, label, onClick = () => {} }, idx) => (
              <ListItem
                key={`setting-${idx}`}
                onClick={() => { onClick(); setOpenSettingsMobile(false) }}
                className={'w-100 hover-no-border py-2'}
                hasHover
                Left={<span className={'d-flex flex-row align-items-center'}><Icon size={15} className={'mr-2'} />{label}</span>}
                Right={<div className={'hover-icon'}><IconArrowRight /></div>}
                showBottomLine
              />
            ))}
          </div>
        </ModalLayout>
      </div>
    </>
  )
}

export default Layout
